var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "row items-center gutter-x-sm",
        on: {
          keyup: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.handleSave($event)
          }
        }
      },
      [
        _c(
          "q-field",
          {
            staticClass: "col-12 col-md-2 q-ma-none",
            attrs: {
              error: _vm.errors.has("quantity"),
              "error-label": _vm.errors.first("quantity")
            }
          },
          [
            _c("q-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required",
                  expression: "'required'",
                  modifiers: { disable: true }
                }
              ],
              staticClass: "no-shadow",
              attrs: {
                type: "number",
                name: "quantity",
                "float-label": _vm.$t("quantity"),
                color: "grey-2",
                "inverted-light": ""
              },
              model: {
                value: _vm.item.quantity,
                callback: function($$v) {
                  _vm.$set(_vm.item, "quantity", $$v)
                },
                expression: "item.quantity"
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "col-12 col-md q-ma-none",
            attrs: {
              error: _vm.errors.has("itemName"),
              "error-label": _vm.errors.first("itemName")
            }
          },
          [
            _c(
              "q-input",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:150",
                    expression: "'required|min:1|max:150'",
                    modifiers: { disable: true }
                  }
                ],
                ref: "itemName",
                staticClass: "no-shadow",
                attrs: {
                  name: "itemName",
                  type: "search",
                  autocomplete: "off",
                  "float-label": _vm.$t("item_name"),
                  color: "grey-2",
                  "inverted-light": "",
                  autofocus: ""
                },
                on: { input: _vm.handleItemNameUpdate },
                model: {
                  value: _vm.item.itemName,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "itemName", $$v)
                  },
                  expression: "item.itemName"
                }
              },
              [
                _c("infinite-autocomplete", {
                  attrs: {
                    debounce: _vm.defaultSearchDebounce,
                    "min-characters": 0,
                    "max-results": 200,
                    "max-height": "300px"
                  },
                  on: {
                    fetch: _vm.handleInfiniteScroll,
                    search: _vm.handleSearch,
                    selected: _vm.handleSearchSelect,
                    show: function($event) {
                      _vm.popoverOpen = true
                    },
                    hide: _vm.handlePopoverHide
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "col-6 col-md-2 q-ma-none responsive-margin",
            attrs: {
              error: _vm.errors.has("priceNet"),
              "error-label": _vm.errors.first("priceNet")
            }
          },
          [
            _c("q-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required|max:45",
                  expression: "'required|max:45'",
                  modifiers: { disable: true }
                }
              ],
              staticClass: "no-shadow",
              attrs: {
                type: "number",
                name: "priceNet",
                value: _vm._f("asDecimal")(_vm.item.price),
                "float-label": _vm.$t("price_net"),
                suffix: _vm.currencySymbol,
                color: "grey-2",
                "inverted-light": ""
              },
              on: {
                input: function(val) {
                  return (_vm.item.price = _vm.priceInCents(val, _vm.currency))
                }
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "col-6 col-md-2 q-ma-none responsive-margin",
            attrs: {
              error: _vm.errors.has("salesTax"),
              "error-label": _vm.errors.first("salesTax")
            }
          },
          [
            _c("sales-tax-input", {
              staticClass: "no-shadow",
              attrs: {
                "float-label": _vm.$t("sales_tax"),
                "use-default": "",
                required: "",
                color: "grey-2",
                "inverted-light": ""
              },
              on: {
                show: function($event) {
                  _vm.popoverOpen = true
                },
                hide: _vm.handlePopoverHide
              },
              model: {
                value: _vm.item.salesTax,
                callback: function($$v) {
                  _vm.$set(_vm.item, "salesTax", $$v)
                },
                expression: "item.salesTax"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "row gutter-x-sm",
        on: {
          keyup: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.handleSave($event)
          }
        }
      },
      [
        _c(
          "q-field",
          {
            staticClass: "col q-ma-none responsive-margin",
            attrs: {
              error: _vm.errors.has("unitName"),
              "error-label": _vm.errors.first("unitName")
            }
          },
          [
            _c(
              "q-input",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "max:45",
                    expression: "'max:45'",
                    modifiers: { disable: true }
                  }
                ],
                ref: "unitName",
                staticClass: "no-shadow",
                attrs: {
                  name: "unitName",
                  "float-label": _vm.$t("unit_name"),
                  color: "grey-2",
                  "inverted-light": ""
                },
                model: {
                  value: _vm.item.unitName,
                  callback: function($$v) {
                    _vm.$set(_vm.item, "unitName", $$v)
                  },
                  expression: "item.unitName"
                }
              },
              [
                _c("q-autocomplete", {
                  attrs: {
                    "static-data": { field: "label", list: _vm.defaultUnits },
                    "min-characters": 0
                  },
                  on: {
                    show: function($event) {
                      _vm.popoverOpen = true
                    },
                    hide: _vm.handlePopoverHide
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("discount-input", {
          staticClass: "col q-ma-none responsive-margin no-shadow",
          attrs: {
            currency: _vm.currency,
            "discount-absolute": _vm.item.discountAbsolute,
            "discount-relative": _vm.item.discountRelative,
            type: _vm.discountType,
            "float-label": _vm.$t("discount"),
            color: "grey-2",
            "inverted-light": ""
          },
          on: {
            inputDiscountAbsolute: function($event) {
              _vm.item.discountAbsolute = $event
            },
            inputDiscountRelative: function($event) {
              _vm.item.discountRelative = $event
            }
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "q-field",
          {
            staticClass: "col-12 q-ma-none responsive-margin",
            attrs: {
              error: _vm.errors.has("description"),
              "error-label": _vm.errors.first("description")
            }
          },
          [
            _c("q-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "max:2000",
                  expression: "'max:2000'",
                  modifiers: { disable: true }
                }
              ],
              staticClass: "no-shadow",
              attrs: {
                type: "textarea",
                name: "description",
                rows: "2",
                "float-label": _vm.$t("description"),
                color: "grey-2",
                "inverted-light": ""
              },
              model: {
                value: _vm.item.description,
                callback: function($$v) {
                  _vm.$set(_vm.item, "description", $$v)
                },
                expression: "item.description"
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "flex q-mt-lg justify-end" },
      [
        _c(
          "q-btn",
          {
            staticClass: "q-mr-md",
            attrs: { color: "black", flat: "" },
            on: { click: _vm.handleCancel }
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("cancel")) + "\n    ")]
        ),
        _c(
          "q-btn-dropdown",
          {
            staticClass: "no-shadow",
            attrs: { label: _vm.saveButtonText, color: "green", split: "" },
            on: { click: _vm.handleSave }
          },
          [
            _c(
              "q-list",
              { attrs: { link: "" } },
              [
                _c(
                  "q-item",
                  {
                    directives: [
                      { name: "close-overlay", rawName: "v-close-overlay" }
                    ],
                    nativeOn: {
                      click: function($event) {
                        return _vm.handleAddTemplate($event)
                      }
                    }
                  },
                  [
                    _c(
                      "q-item-main",
                      [
                        _c("q-item-tile", { attrs: { label: "" } }, [
                          _vm._v(_vm._s(_vm.$t("add_item_as_template")))
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }